<template lang='pug'>
div#app.text-light
  b-container
    b-row(align-h="center").mt-5
      b-col(md="5")
        b-img(alt="Vue logo" :src="require('@/assets/logo-bw.png')" fluid)

    b-row(align-h="center" no-gutters).mt-4.text-center.font-weight-light
      p.text-big Anthony Overton, PT 💪

    b-row(align-h="center")
      b-button(href="https://www.instagram.com/official_aestheticss/" variant="primary")
        strong IG: official_aestheticss

    b-row(align-h="center").mt-5
      b-col(sm)
        b-img-lazy(alt="Vue logo" :src="require('@/assets/small-2.jpg')" fluid thumbnail).shadow.mb-2
      b-col(sm)
        b-img-lazy(alt="Vue logo" :src="require('@/assets/small-3.jpg')" fluid thumbnail).shadow.mb-2
      b-col(sm)
        b-img-lazy(alt="Vue logo" :src="require('@/assets/small-1.jpg')" fluid thumbnail).shadow.mb-2

    b-row(align-h="center").mt-5
      b-col(md="8" lg="7")
        p G'day I'm Anthony Overton, an Australian personal trainer and fitness enthusiast. I'm also the founder and coach of Official Aesthetics.
        p Through my own bad experiences with getting misleading information in the world of fitness, I found myself questioning what I was reading in the popular fitness magazines and online articles.
        p I've always known that I wanted to be in a position in which I could help people change their lives. Through my extensive training and studies with the ISSA along with hundreds of hours of research, I found the understanding for unlocking the body of your dreams using methods proven by science.
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'App',
  components: {
    HelloWorld
  }
}
</script>

<style lang="sass">
body
  background-color: #343a40 !important

#app
  font-family: Avenir, Helvetica, Arial, sans-serif
  font-size: 16pt
  -webkit-font-smoothing: antialiased
  -moz-osx-font-smoothing: grayscale
  margin-bottom: 4rem

.text-big
  font-size: 18pt
  font-weight: 300
</style>
